export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    var hours=date.getHours()
    var minutes=date.getMinutes()
    var second=date.getSeconds()
    hours=hours.toString().padStart(2,'0')
    minutes=minutes.toString().padStart(2,'0')
    second=second.toString().padStart(2,'0')
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': hours,
        'm+': minutes,
        's+': second
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    var day=date.getDay()
    var week=''
    if(day==0){week='星期日'}
    if(day==1){week='星期一'}
    if(day==2){week='星期二'}
    if(day==3){week='星期三'}
    if(day==4){week='星期四'}
    if(day==5){week='星期五'}
    if(day==6){week='星期六'}
    return fmt+' '+week;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}

export function testNull(that,val='',name=''){
  if(val==''||val==null||!val){
    that.$message({
        type: 'warning',
        message: name+'不能为空',
    })
    return false
  }else{
    return true
  }
}

export function testLength(that,val='',len=50,name=''){
  if(val.length>len){
    that.$message({
       message: name+'不能超过'+len+'个字',
       type: 'warning'
    })
    return false
  }else{
    return true
  }
}

export function testNumber(that,val='',len=50,name=''){
  if(val>len){
    that.$message({
       message: name+'不能超过'+len,
       type: 'warning'
    })
    return false
  }else{
    return true
  }
}



// WEBPACK FOOTER //
// ./src/api/common.js